import ToastHelper from './ToastHelper'

const DownloadXMLFileHelper = async (xmlString) => {
  if (!xmlString) {
    ToastHelper.showError('Lỗi khi tải hóa đơn XML')
    return
  }

  try {
    const downloadXml = (xmlText) => {
      const blob = new Blob([xmlText], {
        type: 'application/xml;charset=utf-8',
      })
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = downloadUrl
      link.download = 'invoice.xml'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(downloadUrl)
    }

    const trimmedXmlString =
      typeof xmlString === 'string' ? xmlString.trim() : xmlString

    const xmlLink =
      typeof trimmedXmlString === 'string' &&
      /^(https?:\/\/)/i.test(trimmedXmlString)

    if (xmlLink) {
      const response = await fetch(trimmedXmlString)

      if (!response.ok) {
        throw new Error('Lỗi khi tải tệp XML từ đường dẫn')
      }

      const contentType = response.headers.get('content-type') || ''

      if (
        contentType.includes('application/xml') ||
        contentType.includes('text/xml')
      ) {
        const xmlText = await response.text()
        downloadXml(xmlText, 'invoice.xml')
      } else {
        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = downloadUrl
        link.download = 'invoice.xml'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        window.URL.revokeObjectURL(downloadUrl)
      }

      return
    }

    downloadXml(trimmedXmlString, 'invoice.xml')
  } catch (error) {
    console.error('Download XML error:', error)
    ToastHelper.showError('Lỗi khi tải hóa đơn XML')
  }
}

export default DownloadXMLFileHelper
